<template>
  <div>
    <Top />
    <vue-signature v-bind:is-show-sign.sync="isShowSign" @set-sign="setElectronicSignatureFile"></vue-signature>
    <div class="maindiv pproject-wrap  bg-gray">
      <Banner />
      <div class="mt25 bgw htmldiv">
        <banner-title :tname="pro_name" />
        <div class="ncont detail" v-if="flow==0">
          <div class="sign-row center-row">
            <a class="sub-button" href="javascript:;" @click="flow=1">去报名</a>
            <a class="sub-button" href="javascript:;" @click="flow=2">报名查询</a>
          </div>
        </div>

        <div v-else-if="flow==1" class="ncont detail">
          <div class="sign-row"  v-if="listData.train_level">
            <div class="label">
              <label>级别</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.train_level" @change="info.apply_condition=''">
                  <option v-for="(item,index) in listData.train_level" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <template v-if="listData['apply_condition'] && listData['apply_condition'][info.train_level]">
            <div class="sign-row sign-row26" v-for="(item,index) in listData['apply_condition'][info.train_level]">
              <div class="label" style="vertical-align: top;">
              </div>
              <div class="content">
                <div class="content-item">
                  <input v-model="info.apply_condition" type="radio" :value="index" /><label>{{item}}</label>
                </div>
              </div>
            </div>
          </template>

          <div class="hr-div"></div>

          <div class="sign-row">
            <div class="label">
              <label>姓名</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.nm" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>证件类型</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.cid_type">
                  <option v-for="(item,index) in listData.cid_type" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>证件号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.cid" @blur="changeCidInput" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>性别</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.gender">
                  <option v-for="(item,index) in listData.promotion_gender" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>非身份证类型者必填）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>出生日期</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input type="date" class="content-select" v-model="info.birthday" />
                <span class="content-msg">（<span style='color: red;'>*</span>非身份证类型者必填）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>民族</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.nation">
                  <option v-for="(item,index) in listData.nation" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>政治面貌</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.political_outlook">
                  <option v-for="(item,index) in  listData.politic_status" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>文化程度</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.edu_level">
                  <option v-for="(item,index) in listData.edu_level" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>手机号码</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.mobile" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>考生来源</label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.source">
                  <option v-for="(item,index) in listData.source" :value="index">{{item}}</option>
                </select>
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>所在单位</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.company" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>通讯地址</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.address2" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>本职业工作年限</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input type="month" class="content-select content-select3" v-model="info.career_start"
                  @change="changeCareer" style="width: 205px"/>
                <input class="content-select content-select3" type="text" v-model="info.career_years" readonly />

                <!--                <label class="insert-label">至</label>-->
                <!--                <input type="month" class="content-select content-select3" />-->
                <span class="content-msg">（<span style='color: red;'>*</span>必填项,温馨提示：时间日期可手动输入）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>电子邮箱</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="info.email" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>电子签名</label>
            </div>
            <div class="content">
              <div class="content-item signature" @click="isShowSign=true">
                <input type="checkbox" class="content-select" v-model="!!info.electronic_signature" />
                <img v-if="info.electronic_signature" :src="electronic_signature_jpg" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>
          <template
            v-if="!(info.train_level == 5 || (info.train_level == 4 && (info.apply_condition == 2 || info.apply_condition == 3)) || !info.train_level || !info.apply_condition)">
            <div class="sign-row">
              <div class="label">
                <label>现有资格证书号码</label>
              </div>
              <div class="content">
                <div class="content-item">
                  <input class="content-select" v-model="info.cert_info" />
                  <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
                </div>
              </div>
            </div>
            <div class="sign-row">
              <div class="label">
                <label>现有证书工种名称</label>
              </div>
              <div class="content">
                <div class="content-item">
                  <!--                <input class="content-select" v-model="info.cert_nm"/>-->
                  <select class="content-select" v-model="info.cert_nm">
                    <option v-for="item in cert_nm" :value="item">{{item}}</option>
                  </select>
                  <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
                </div>
              </div>
            </div>
            <div class="sign-row">
              <div class="label">
                <label>现有资格证书等级</label>
              </div>
              <div class="content">
                <div class="content-item">
                  <!--                <input class="content-select" v-model="info.cert_level"/>-->
                  <select class="content-select" v-model="info.cert_level">
                    <option v-for="(item,index) in listData.train_level" :value="index">{{item}}</option>
                  </select>
                  <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
                </div>
              </div>
            </div>
            <div class="sign-row">
              <div class="label">
                <label>证书取得时间</label>
              </div>
              <div class="content">
                <div class="content-item">
                  <input type="date" class="content-select" v-model="info.cert_date" />
                  <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
                </div>
              </div>
            </div>
          </template>

          <div class="hr-div"></div>
          <div class="sign-row">
            <div class="label" style="vertical-align: top;">
              <label>证件照</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_passport" @update-image="getPassportFiles" @clear-image="clearPassportFiles"
                  max-count="1" :param-width="'215px'" :param-height="'300px'" />
                <!--                <input ref="fileCid" type="file" multiple="multiple" @change="getCidFiles($event)" accept="image/*" />-->
                <!--                <input type="text" class="content-select" disabled :value="fileCid" />-->
                <!--                <a class="changeButton" href="javascript:;" @click="changeCid">上传</a>-->
                <span class="content-msg" style="display: inline-block">（<span style='color: red;'>*</span>必传，重要提示:
                  1.照片必需是近期、正面、免冠、白底、清晰的本人证件照；（拒绝使用扫描、PS等处理过的图片）。
                  2.照片格式应为JPG或JPEG格式，且以考生证件号码加姓名为名字，如“证件号码_张三.jpg”，文件大于30K且小于2M，大于215*300（宽*高）像素。3.照片将用于证书打印，照片不符合以上要求将无法通过资格复审。）</span>
              </div>
            </div>
          </div>
          <div class="sign-row" v-if="info.cid_type>''">
            <div class="label">
              <label>{{listData.cid_type[info.cid_type]}}正面</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_cid" @update-image="getCidFiles" @clear-image="clearCidFiles" max-count="1"
                  param-width="300px" param-height="215px" />
                <!--                <input ref="fileCid" type="file" multiple="multiple" @change="getCidFiles($event)" accept="image/*" />-->
                <!--                <input type="text" class="content-select" disabled :value="(fileCid!='')?fileCid:info.pic_cid" />-->
                <!--                <a class="changeButton" href="javascript:;" @click="changeCid">上传</a>-->
                <span class="content-msg">（<span style='color: red;'>*</span>必传，重要提示:
                  文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）</span>
              </div>
            </div>
          </div>
          <div class="sign-row" v-if="info.cid_type>''">
            <div class="label">
              <label>{{listData.cid_type[info.cid_type]}}反面</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_cid_back" @update-image="getCidFilesBack" @clear-image="clearCidFilesBack"
                  max-count="1" param-width="300px" param-height="215px" />
                <span class="content-msg">（<span style='color: red;'>*</span>必传，重要提示:
                  文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）</span>
              </div>
            </div>
          </div>
          <div class="sign-row" v-if="info.edu_level>2">
            <div class="label">
              <label>学历证书</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_edu" @update-image="getEduFiles" @clear-image="clearEduFiles" max-count="1" />
                <!--                <input ref="fileEducation" type="file" @change="getEduFiles($event)" accept="image/*"/>-->
                <!--                <input type="text" class="content-select" disabled :value="(fileEducation!='')?fileEducation:info.pic_edu" />-->
                <!--                <a class="changeButton" href="javascript:;" @click="changeEducation">上传</a>-->
                <span class="content-msg">（<span
                    style='color: red;'>*</span>必填项，文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）</span>
              </div>
            </div>
          </div>

          <div class="sign-row" v-if="!(info.train_level == 5 || (info.train_level == 4 && (info.apply_condition == 2 || info.apply_condition == 3)) || !info.train_level || !info.apply_condition) && (info.cert_info>'' || info.cert_nm>'')">
		  
            <div class="label">
              <label>原资格证书</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_career_cert" @update-image="getQuaFiles" @clear-image="clearQuaFiles"
                  max-count="3" />
                <!--                <input ref="fileQualifications" type="file" @change="getQuaFiles($event)" accept="image/*" />-->
                <!--                <input type="text" class="content-select" disabled :value="(fileQualifications!='')?fileQualifications:info.pic_career_cert"/>-->
                <!--                <a class="changeButton" href="javascript:;" @click="changeQualifications">上传</a>-->
                <span class="content-msg">（<span
                    style='color: red;'>*</span>必填项，文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）</span>
              </div>
            </div>
          </div>

          <div class="hr-div"></div>
          <div class="sign-row center-row" v-if="info.id">
            <a class="sub-button" href="javascript:;" v-if="info.status == 1" style="background: #9facb7;border-color: #9facb7;">已通过审核</a>
            <a v-else-if="info.status == 2 || info.save == 2" class="sub-button" href="javascript:;" @click="submitSign(1)">立即修改</a>
          </div>
          <div class="sign-row center-row" v-else>
            <a class="sub-button mr30" href="javascript:;" @click="submitSign(1)" v-if="cansub == 1">立即报名</a>
            <a class="sub-button1 mr30" href="javascript:;" v-else>立即报名</a>
            <a class="sub-button" href="javascript:;" @click="submitSign(2)">保存草稿</a>
          </div>
        </div>

        <div class="ncont detail" v-if="flow==2">
          <div class="sign-row">
            <div class="label">
              <label>请输入手机号</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model.trim="search_code" />
                <span class="content-msg">（<span style='color: red;'>*</span>必填项）</span>
              </div>
            </div>
          </div>

          <div class="hr-div"></div>
          <template v-if="searchData && searchData.id">
            <!-- @click="selectSearch(searchData)" -->
            <div style="margin-left: 35px;margin-bottom: 10px;" >
              {{searchData['nm']}}-{{searchData['cid']}}-
              <span v-if="searchData.status==1" style="color: green;">(审核通过)</span>
              <span v-else-if="searchData.status==2" style="color: red;">(审核未通过<span v-if="searchData.memo">,{{searchData.memo}}</span>)</span>
              <span v-else-if="searchData.save==2" style="color: red;">(草稿)</span>
              <span v-else style="color: red;">(审核中)</span>
            </div>
            <div v-if="searchData.status==2" class="fs14 lh20" style="padding: 0 50px;">
              <div  v-for="(item,index) in searchData.refuseReasonsStringArray">{{index + 1}}. {{item}}</div>
            </div>

            <div class="sign-row center-row fs16">
              <!--<a v-if="searchData.status==1" class="sub-button trans3 mr20" href="javascript:;"
                @click="printSign(searchData)">打印申请表</a>-->
              <a v-if="searchData.status==1" href="javascript:;"
                @click="printSign(searchData)"></a>

              <a v-else-if="searchData.status==2 || searchData.save==2" class="sub-button trans3 mr20" href="javascript:;"
                @click="updateSign(searchData)">修改</a>

              <a v-else class="sub-button trans3 mr20" href="javascript:;" @click="showSign(searchData)">查看</a>
              <a class="sub-button trans3" href="javascript:;" @click="$router.go(-1)">返回</a>
            </div>
          </template>
          <div v-else class="sign-row center-row fs16">
            <a class="sub-button trans3 mr20" href="javascript:;" @click="searchSign">立即查询</a>
            <a class="sub-button trans3" href="javascript:;" @click="$router.go(-1)">返回</a>
          </div>
        </div>

        <div class="ncont detail" v-if="flow==3">
          <div class="sign-row center-row">
            <span>操作成功！请通过您手机号进行查询：{{info.mobile}}</span>
          </div>

          <div class="hr-div"></div>

          <div class="sign-row center-row">
            <router-link class="sub-button" to="/train/index">返回首页</router-link>
          </div>

        </div>
      </div>
      <div data-v-fd68d6dc="" class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../top'
import Banner from '../banner'
import Bottom from '../bottom'
import BannerTitle from './signTitle'
import Upload from '../../item/upload'
import vueSignature from '../../item/vueSignature'
export default {
  name: 'sign',

  components: {
    Top,
    Banner,
    Bottom,
    BannerTitle,
    Upload,
    vueSignature
  },

  data () {
    return {
      'cansub': 1,
      'id': 0,
      'project_id': 0,
      'search_code': '',
      'flow': 0,
      'pro_name': '',
      'info': {
        'id': '',
        'train_level': '',
        'apply_condition': '',
        'nm': '',
        'cid_type': '',
        'cid': '',
        'birthday': '',
        'gender': 0,
        'nation': '',
        'politic_status': '',
        'edu_level': '',
        'mobile': '',
        'source': '',
        'company': '',
        'address2': '',
        'career_start': '',
        'career_years': '',
        'email': '',
        'cert_info': '',
        'cert_nm': '',
        'pic_career_cert': '',
        'pic_cid': '',
        'pic_passport': '',
        'pic_cid_back': '',
        'pic_edu': '',
        'save': 0,
        'cert_level': '',
        'cert_date': '',
        'electronic_signature': ''
      },
      'cert_nm': [],
      'cidFiles': [],
      'cidFilesBack': [],
      'passportFiles': [],
      'filePassport': '',
      'eduFiles': [],
      'quaFiles': [],
      'fileEducation': '',
      'fileCid': '',
      'fileCidBack': '',
      'fileQualifications': '',
      'listData': [],
      'searchData': {},
      'isShowSign': false,
      'electronicSignatureFile': '',
      'electronic_signature_jpg': ''
    }
  },

  created () {
    this.pro_name = this.$route.query.name
    this.id = this.$route.query.id
    this.project_id = this.$route.query.project_id
    if (!this.$request.isPc()) {
      this.$router.push({
        path: '/mobile/train/project/sign',
        query: {
          name: this.pro_name,
          id: this.id,
          project_id: this.project_id,
          work_option: this.$route.query.work_option
        }
      })
    }
    var itemJnNameSelect = localStorage.getItem('ITEMJN')
    this.cert_nm = itemJnNameSelect && itemJnNameSelect.split(',')
    console.log(this.cert_nm)
    this.getData()
    
    this.flow = this.$route.query.flow
  },

  mounted () {

  },

  methods: {
    showSign (item) { // 查看申请表 不能编辑 待审核状态
      this.flow = 1
      this.info = item
    },
    updateSign (item) {
      this.info = item
      this.id = this.info.disc_id
      this.pro_name = this.info.discipline.name
      this.flow = 1
      this.electronic_signature_jpg = this.$request.file_server + this.info.electronic_signature
    },
    selectSearch: function (index) {
      this.info = this.searchData[index]
      this.id = this.info.disc_id
      this.pro_name = this.info.discipline.name
      this.flow = 1
      this.electronic_signature_jpg = this.$request.file_server + this.info.electronic_signature
    },
    changeCareer: function () {
      var car = this.info.career_start.split('-')
      console.log(car)
      if (car.length > 1) {
        var year = parseInt(car[0])
        var month = parseInt(car[1])
        var date = new Date()
        var now_year = date.getFullYear()
        if (month > 6 && now_year <= 6) {
          this.info.career_years = now_year - year - 1
        } else {
          this.info.career_years = now_year - year
        }
      }
    },
    getBirth: function (idCard) {
      var birthday = ''
      if (idCard != null && idCard != '') {
        if (idCard.length == 15) {
          birthday = '19' + idCard.slice(6, 12)
        } else if (idCard.length == 18) {
          birthday = idCard.slice(6, 14)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
        // 通过正则表达式来指定输出格式为:1990-01-01
      }
      return birthday
    },
    getSex: function (idCard) {
      var sexStr = ''
      if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
        sexStr = 1
      } else {
        sexStr = 0
      }
      return sexStr
    },
    isCard: function (str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return reg.test(str)
    },
    isPhone: function (str) {
      var reg = /(^1\d{10}$)/
      return reg.test(str)
    },
    changeCidInput: function () {
      if (this.info.cid_type == 1) {
        if (this.isCard(this.info.cid)) {
          this.info.birthday = this.getBirth(this.info.cid)
          this.info.gender = this.getSex(this.info.cid)
        } else {
          alert('不是正确的身份证格式')
        }
      }
      this.changeCidSearch();
    },
    getData: function () {
      this.$request.get('training-skill/skill-appraisal-options', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.listData = response.data.data
          // console.log(response.data.data)
        }
      }, error => {
        console.log(error)
      })
    },
    getPassportFiles: function (e) {
      this.passportFiles = e.target.files
      this.filePassport = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.filePassport += e.target.files[i]['name'] + ';'
      }
    },
    clearPassportFiles: function (e) {
      this.passportFiles = []
      this.filePassport = ''
    },
    getCidFiles: function (e) {
      this.cidFiles = e.target.files
      this.fileCid = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCid += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFiles: function (e) {
      this.cidFiles = []
      this.fileCid = ''
    },

    getCidFilesBack: function (e) {
      this.cidFilesBack = e.target.files
      this.fileCidBack = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCidBack += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFilesBack: function (e) {
      this.cidFilesBack = []
      this.fileCidBack = ''
    },
    getEduFiles: function (e) {
      this.eduFiles = e.target.files
      this.fileEducation = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileEducation += e.target.files[i]['name'] + ';'
      }
    },
    clearEduFiles: function (e) {
      this.eduFiles = []
      this.fileEducation = ''
    },

    getQuaFiles: function (e) {
      this.quaFiles.push(
        e.target.files[0]
      )
      this.fileQualifications = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileQualifications += e.target.files[i]['name'] + ';'
      }
    },
    clearQuaFiles: function (index) {
      var pic_cer = this.info.pic_career_cert
      var pic_cer_arr = pic_cer.split(';')
      pic_cer_arr.splice(index, 1)
      this.info.pic_career_cert = pic_cer_arr.join(';')
      this.quaFiles.splice(index, 1)
      this.fileQualifications = ''
      for (let i = 0; i < this.quaFiles.length; i++) {
        this.fileQualifications += this.quaFiles[i]['name'] + ';'
      }
    },
    setElectronicSignatureFile: function (e, f) {
      this.electronicSignatureFile = e
      this.info.electronic_signature = 'signature.jpg'
      this.electronic_signature_jpg = f
    },
    submitSign: function (save) {
      // this.info.save = save
      console.log(this.info.cid)
      if (!this.info.train_level || !this.info.apply_condition) {
        alert('申报条件（级别）不能为空')
        return false
      }
      if (!this.info.nm) {
        alert('姓名不能为空')
        return false
      }
      if (!this.info.cid) {
        alert('证件号不能为空')
        return false
      }
      if (!this.info.mobile) {
        alert('手机号不能为空')
        return false
      }
      // if (this.info.gender !== '') {
      //   alert('性别不能为空')
      //   return false
      // }
      if (!this.info.birthday) {
        alert('出生日期不能为空')
        return false
      }
      if (!this.info.nation) {
        alert('民族不能为空')
        return false
      }
      if (!this.info.political_outlook) {
        alert('政治面貌不能为空')
        return false
      }
      if (!this.info.edu_level) {
        alert('文化程度不能为空')
        return false
      }
      if (!this.info.source) {
        alert('考生来源不能为空')
        return false
      }
      if (!this.info.company) {
        alert('所在单位不能为空')
        return false
      }
      if (!this.info.address2) {
        alert('通讯地址不能为空')
        return false
      }
      if (!this.info.career_start && save == 1) {
        alert('工作年限不能为空')
        return false
      }
      if (!this.info.email && save == 1) {
        alert('电子邮箱不能为空')
        return false
      }
      if (this.info.cid_type == 1 && !this.isCard(this.info.cid)) {
        alert('身份证格式错误')
        return false
      }
      if (!this.isPhone(this.info.mobile)) {
        alert('手机号格式错误')
        return false
      }
      if (!this.info.electronic_signature && save == 1) {
        alert('未签名')
        return false
      }
      if (save == 1) {
        if (this.id == '' || this.id == 0) {
          alert('未关联项目')
          return false
        }
		let flag = this.info.train_level == 1 || this.info.train_level == 2 || this.info.train_level == 3
        if (flag) {
          if (!this.info.cert_info) {
            alert('证书名称不能为空')
            return false
          }
          if (!this.info.cert_nm) {
            alert('证书号不能为空')
            return false
          }
          if (!this.info.cert_level) {
            alert('证书等级不能为空')
            return false
          }
          if (!this.info.cert_date) {
            alert('证书取得时间不能为空')
            return false
          }
        }
        if (this.info.train_level == 4 && this.info.apply_condition == 1) {
          if (!this.info.cert_info) {
            alert('证书名称不能为空')
            return false
          }
          if (!this.info.cert_nm) {
            alert('证书号不能为空')
            return false
          }
          if (!this.info.cert_level) {
            alert('证书等级不能为空')
            return false
          }
          if (!this.info.cert_date) {
            alert('证书取得时间不能为空')
            return false
          }
        }
        if (!this.info.pic_passport && !this.filePassport) {
          alert('证件照未上传')
          return false
        }
        if (this.info.cid_type > '') {
          if (!this.info.pic_cid && !this.fileCid) {
            alert(this.listData.cid_type[this.info.cid_type] + '正面未上传')
            return false
          }
          if (!this.info.pic_cid_back && !this.fileCidBack) {
            alert(this.listData.cid_type[this.info.cid_type] + '反面未上传')
            return false
          }
        }
        if (this.info.edu_level >= 3) {
          if (!this.info.pic_edu && !this.fileEducation) {
            alert('学历证书未上传')
            return false
          }
        }
        if (flag && !(this.info.cert_info == '' && this.info.cert_nm == '')) {
          if (!this.info.pic_career_cert && !this.fileQualifications) {
            alert('资格证书未上传')
            return false
          }
        }
      }
      this.info.save = save
      let param = new FormData()
      if (this.electronicSignatureFile) {
        param.append('electronic_signature', this.electronicSignatureFile, 'signature.jpg')
      }
      if (this.passportFiles.length > 0) {
        param.append('pic_passport', this.passportFiles[0], this.passportFiles[0].name)
      }
      if (this.cidFiles.length > 0) {
        param.append('pic_cid', this.cidFiles[0], this.cidFiles[0].name)
      }
      if (this.cidFilesBack.length > 0) {
        param.append('pic_cid_back', this.cidFilesBack[0], this.cidFilesBack[0].name)
      }
      if (this.eduFiles.length > 0) {
        param.append('pic_edu', this.eduFiles[0], this.eduFiles[0].name)
      }
      if (this.quaFiles.length > 0) {
        for (let i = 0; i < this.quaFiles.length; i++) {
          param.append('pic_career_cert[]', this.quaFiles[i], this.quaFiles[i].name)
        }
      }
      for (let key in this.info) {
        param.append(key, this.info[key])
      }
      param.append('class_id', this.id)
      param.append('discipline_id', this.project_id)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      } // 添加请求头

      this.cansub = 0
      this.$request.postFile('training-skill/skill-appraisal-enroll', param, config, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.cansub = 1
          // 报名成功
          if (save == 2) {
            this.flow = 3
          } else {
            this.flow = 3
          }
        } else {
          this.cansub = 1
          alert(response.data.message)
        }
      }, error => {
        console.log(error)
      })
    },
    changeCid: function () {
      this.$refs.fileCid.dispatchEvent(new MouseEvent('click'))
    },
    changeEducation: function () {
      this.$refs.fileEducation.dispatchEvent(new MouseEvent('click'))
    },
    changeQualifications: function () {
      this.$refs.fileQualifications.dispatchEvent(new MouseEvent('click'))
    },
    searchSign: function () {
      if (this.id == '' || this.id == 0) {
        alert('未关联项目')
        return false
      }
      var param = {
        search_code: this.search_code,
        class_id: this.id,
        train_id: this.project_id
      }
      this.$request.get('training-skill/get-skill-appraisal-record', param, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.searchData = response.data.data
          // this.flow = 1;
        } else {
          alert('未报名')
        }
      }, error => {
        console.log(error)
      })
    },
    changeCidSearch: function () { 
      //查询报名记录
      var param = {
        class_id: this.id,
        train_id: this.project_id,
        cid_type: this.info.cid_type,
        cid: this.info.cid,
      }
      this.$request.get('training-skill/get-skill-appraisal-record-by-cid', param, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.info = response.data.data
          // this.flow = 1;
         } //else {
        //   alert('未报名')
        // }
      }, error => {
        console.log(error)
      })
  }

  }
  
  
}
</script>

<style scoped>
  .pproject-wrap .detail {
    padding: 50px 55px 40px;
  }

  .hr-div {
    width: 100%;
    height: 1px;
    border-top: 1px solid rgb(233, 233, 233);
    margin: 30px 0
  }

  .sign-row {
    min-height: 40px;
    line-height: 26px;
    margin-top: 14px;
  }

  .sign-row26 {
    min-height: 26px;
  }

  .sign-row .label {
    width: 150px;
    display: inline-block;
    line-height: 35px;
    text-align: right;
    font-size: 16px;
    color: rgb(51, 51, 51);
    vertical-align: top;
  }

  .sign-row .content {
    width: 950px;
    display: inline-block;
    margin-left: 40px;
  }

  .sign-row .content-select {
    width: 345px;
    height: 34px;
    line-height: 34px;
    border: 1px solid rgb(212, 218, 221);
    background: rgb(243, 243, 243);
    /*color: rgb(212, 218, 221);*/
    color: #000;
  }

  .sign-row .content-select3 {
    width: 120px;
    margin-right: 15px;
  }

  .sign-row .content-select2 {
    width: 61px;
    margin-right: 10px;
  }

  .sign-row .content-select1 {
    width: 50px;
    margin-right: 5px;
  }

  .sign-row .content-item {
    vertical-align: middle;
    color: rgb(119, 119, 119);
  }

  .sign-row .content-item .insert-label {
    width: 26px;
  }

  .sign-row .content-item input[type=checkbox] {
    vertical-align: middle;
    width: 18px;
    height: 18px;
    margin-right: 12px;
    margin-top: 5px;
  }

  .sign-row .content-item label {
    vertical-align: top;
    display: inline-block;
    width: 900px;
  }

  .sign-row .content-item input[type=file] {
    display: none;
  }

  .sign-row .content-item .changeButton {
    vertical-align: middle;
    display: inline-block;
    width: 48px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border: 1px solid #d4dadd;
    background: #f3f3f3;
  }

  .sign-row .sub-button {
    display: inline-block;
    margin: 0 auto;
    width: 180px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    /*background: #147ad8;*/
    color: #147ad8;
    border: 1px solid #147ad8;
    border-radius: 5px;
  }

  .center-row {
    text-align: center;
  }

  .content-msg {
    display: inline-block;
    line-height: 35px;
    vertical-align: top;
  }

  .signature {
    position: relative;
  }

  .signature::before {
    content: '';
    display: block;
    z-index: 100;
    width: 35px;
    height: 35px;
    position: absolute;
  }

  .sign-row .content-select {
    padding: 0 20px;
  }

  .sign-row .content-select:not(select):focus,
  .sign-row.content-select:not(select):active {
    outline: none;
    background: #fff;
    border-color: #147ad8;
    box-shadow: 0 0 15px #147ad8;
  }
   .sign-row .sub-button:hover{
     background: #147ad8;
     color: #fff;
   }
   .sign-row .sub-button1 {
    display: inline-block;
    margin: 0 auto;
    width: 180px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    /*background: #147ad8;*/
    color: gray;
    border: 1px solid gray;
    border-radius: 5px;
  }
  .sign-row .sub-button1:hover{
     background: gray;
     color: #fff;
   }
</style>


// WEBPACK FOOTER //
// src/components/train/project/sign.vue